import { lazy } from 'react';

// Pantallas secundarias en chunks diferidos para aligerar el primer arranque.
export const NewOrderPage = lazy(() =>
  import('./features/orders/NewOrderPage.tsx').then((m) => ({ default: m.NewOrderPage })),
);
export const OrderDetailPage = lazy(() =>
  import('./features/order-detail/OrderDetailPage.tsx').then((m) => ({ default: m.OrderDetailPage })),
);
export const DiagnosisWizardPage = lazy(() =>
  import('./features/order-detail/DiagnosisWizardPage.tsx').then((m) => ({ default: m.DiagnosisWizardPage })),
);
export const TeamPage = lazy(() => import('./features/team/TeamPage.tsx').then((m) => ({ default: m.TeamPage })));
export const AccountPage = lazy(() =>
  import('./features/account/AccountPage.tsx').then((m) => ({ default: m.AccountPage })),
);
export const NotificationsPage = lazy(() =>
  import('./features/notifications/NotificationsPage.tsx').then((m) => ({ default: m.NotificationsPage })),
);
export const ClientsPage = lazy(() =>
  import('./features/clients/ClientsPage.tsx').then((m) => ({ default: m.ClientsPage })),
);
export const ClientDetailPage = lazy(() =>
  import('./features/clients/ClientDetailPage.tsx').then((m) => ({ default: m.ClientDetailPage })),
);
export const QuotePage = lazy(() => import('./features/quotes/QuotePage.tsx').then((m) => ({ default: m.QuotePage })));
export const NewQuotePage = lazy(() =>
  import('./features/quotes/NewQuotePage.tsx').then((m) => ({ default: m.NewQuotePage })),
);
export const QuotesListPage = lazy(() =>
  import('./features/quotes/QuotesListPage.tsx').then((m) => ({ default: m.QuotesListPage })),
);
